import React, { useState, Fragment, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearError,
    subscribeToNewsletter,
    submitError,
} from '../Actions/Newsletter.action';
import { translate } from '../Services/translation';
import { newsletterEmailSchema } from './Newsletter.ValidationSchema';

const Newsletter = () => {
    const dispatch = useDispatch();
    const { result, errors = {} } = useSelector((state) => state.newsletter);
    const { isSuccessful, receivedResponse, message } = result;
    const [email, setEmail] = useState('');

    const onSubmitError = useCallback(
        (error) => {
            dispatch(submitError(error));
        },
        [dispatch]
    );

    const addError = (error, addressPath = 'emailInput') => {
        error.path = `${addressPath}`;
        onSubmitError(error);
    };

    const newsletterSubscribe = useCallback(() => {
        newsletterEmailSchema
            .validate({ email })
            .then(() => {
                dispatch(subscribeToNewsletter(email));
                dispatch(clearError());
            })
            .catch((error) => addError(error));
    }, [email, dispatch]);

    const renderResponseMessage = () => (
        <div className="newsletter-column">
            <div className="newsletter-text-section">
                <h4
                    className={
                        isSuccessful
                            ? 'successful-newsletter-subscription'
                            : 'failed-newsletter-subscription'
                    }
                >
                    {isSuccessful
                        ? message
                        : translate('newsletter.failedsubscription')}
                </h4>
            </div>
        </div>
    );

    const renderNewsletterForm = () => (
        <div className="newsletter-column">
            <div className="newsletter-text-section">
                <h4>{translate('newsletter.title')}</h4>
                <p>
                    {translate('newsletter.readprivacypolicy') + ' '}
                    <a href={translate('newsletter.privacypolicylink')}>
                        {translate('newsletter.privacypolicytext').trim()}
                    </a>
                </p>
            </div>
            <div className="newsletter-input-section-wrapper">
                <div className="newsletter-input-section__errors-span">
                    {errors['emailInput'] && (
                        <span
                            className="form__validator--error form__validator--top-narrow"
                            data-error-for={'emailInput'}
                        >
                            {errors['emailInput'][0]}
                        </span>
                    )}
                </div>
                <div className="newsletter-input-section">
                    <input
                        type="email"
                        onChange={(event) => setEmail(event.target.value)}
                        value={email}
                        className="newsletter-email-box"
                        placeholder={translate('newsletter.emailfieldtext')}
                    />
                    <input
                        onClick={newsletterSubscribe}
                        className="newsletter-subscribe-button"
                        value={translate('newsletter.buttontext')}
                        type="submit"
                    />
                </div>
            </div>
        </div>
    );

    return (
        <Fragment>
            {receivedResponse
                ? renderResponseMessage()
                : renderNewsletterForm()}
        </Fragment>
    );
};

export default Newsletter;
